import { Booking } from '@wix/bookings-checkout-api';

export const isAppointmentBooking = (booking: Booking): boolean => {
  return booking.bookedEntity?.tags?.includes('INDIVIDUAL') ?? false;
};

export const isClassBooking = (booking: Booking): boolean => {
  return booking.bookedEntity?.tags?.includes('GROUP') ?? false;
};
